jQuery(document).ready(function ($) {
    $(document).on('click', '.header__search', function () {
        $('.search__global').addClass('open');
    });


    $(document).on('click', '#closeSearch', function () {
        $('.search__global').removeClass('open');

    })
})